import { useMutation } from '@apollo/client'

import { atlasClient } from 'graphql/client'
import { atlas } from 'graphql/tags'

import { ValidatedOrders } from './ImportOrders.types'

const IMPORT_VALIDATED_ORDERS = atlas`#graphql
  mutation ImportValidatedOrders($input: ImportValidatedOrdersInput!) {
    importValidatedOrders(input: $input) {
      importJobIdentifier
    }
  }
`

export const useImportValidatedOrders = (): Function => {
  const [mutation] = useMutation(IMPORT_VALIDATED_ORDERS, {
    client: atlasClient,
  })

  const importValidatedOrders = async (
    validatedOrders: ValidatedOrders,
  ): Promise<object> =>
    await mutation({
      variables: {
        input: {
          validatedOrdersIdentifier: validatedOrders?.validatedOrdersIdentifier,
          validatedOrdersUrl: validatedOrders?.validatedOrdersUrl,
        },
      },
    })

  return importValidatedOrders
}
